import { render, staticRenderFns } from "./empty-layout.vue?vue&type=template&id=644963ac&scoped=true&"
import script from "./empty-layout.vue?vue&type=script&lang=ts&"
export * from "./empty-layout.vue?vue&type=script&lang=ts&"
import style0 from "./empty-layout.vue?vue&type=style&index=0&id=644963ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644963ac",
  null
  
)

export default component.exports